/**
 * The markup of shared.popups.WallPreviewPopup (design handoff "Aperçu 3D cadres") :
 *   - desktop : the panel on the left ("Modifier", title, price, Finition, Taille, Pièce) ; the
 *     room on the right, its hint, its view bar, and the cart button in its top right corner
 *   - mobile  : the room on top, "Modifier" and the view bar over it ; a sheet at the bottom with
 *     the title, Finition / Taille / Pièce as tabs over a fixed height, the cart button
 *
 * Every control is a button carrying data-action, handled by the popup.
 *
 *   update(values)     any of title, price, cart, finishLabel, finishes, sizes, rooms, view, measure, tab
 *   band()             mobile : the free band of the scene, between the top bar and the sheet
 *   fitScene()         mobile : the scene down to under the sheet's rounded top
 *   loading(on)
 */
fx.ns("shared.preview3d", class WallPreviewView extends fx.Component {

    get mobile()
    {
        return !!(this.data && this.data.mobile);
    }

    create()
    {
        super.create();

        this.addClass(this.mobile ? "wpMobile" : "wpDesktop");
    }

    loading(on)
    {
        this.toggleClass("wpLoading", !!on);      // not "loading" : fx styles that one on every component (centred text, no pointer events)
    }

    update(values)
    {
        let text = (selector, value) => { if (value !== undefined) this.find(selector).textContent = value; };

        text(".wpTitle", values.title);
        text(".wpPrice", values.price);
        text(".wpCart", values.cart);
        if (!this.mobile)
            text(".wpFinishLabel", values.finishLabel);

        if (values.finishes)
            this.find(".wpFinishes").innerHTML = values.finishes.map((f) =>
                '<button type="button" class="wpCard wpFinish' + (f.selected ? " selected" : "") + '" data-action="finish" data-finish="' + f.code + '" role="radio" aria-checked="' + f.selected + '" aria-label="' + f.label + '">' +
                    '<span class="wpThumb ' + f.code + '"><span></span></span>' +
                    '<span class="wpShort">' + f.short + '</span>' +
                '</button>').join("");

        if (values.sizes)
        {
            let factor = this.mobile ? 0.45 : 0.5;
            this.find(".wpSizes").innerHTML = values.sizes.map((s) =>
                '<button type="button" class="wpCard wpSize' + (s.selected ? " selected" : "") + '" data-action="size" data-format="' + s.id + '" role="radio" aria-checked="' + s.selected + '">' +
                    '<span class="wpSizeIcon"><span style="width:' + Math.round(Math.min(s.width, 48) * factor) + 'px;height:' + Math.round(Math.min(s.height, 48) * factor) + 'px"></span></span>' +
                    '<span class="wpSizeLabel">' + s.label + '</span>' +
                    '<span class="wpSizePrice">' + s.price + '</span>' +
                '</button>').join("");
        }

        if (values.rooms)
            this.find(".wpRooms").innerHTML = values.rooms.map((r) =>
                '<button type="button" class="wpCard wpRoom' + (r.selected ? " selected" : "") + '" data-action="room" data-room="' + r.index + '" role="radio" aria-checked="' + r.selected + '">' +
                    '<img src="' + r.thumb + '" alt="" draggable="false">' +
                    '<span>' + r.label + '</span>' +
                '</button>').join("");

        if (values.view !== undefined)
            this.findAll(".wpViewBar [data-view]").forEach((button) => {
                let on = button.dataset.view == values.view;
                button.classList.toggle("selected", on);
                button.setAttribute("aria-pressed", on);
            });

        if (values.measure !== undefined)
        {
            let button = this.find(".wpMeasureButton");
            button.classList.toggle("selected", !!values.measure);
            button.setAttribute("aria-pressed", !!values.measure);
        }

        if (values.tab !== undefined && this.mobile)
        {
            this.findAll(".wpTabs [data-tab]").forEach((button) => {
                let on = button.dataset.tab == values.tab;
                button.classList.toggle("selected", on);
                button.setAttribute("aria-selected", on);
            });
            this.findAll(".wpTabBody [data-pane]").forEach((pane) => pane.classList.toggle("selected", pane.dataset.pane == values.tab));
        }
    }

    findAll(selector)
    {
        return this.node ? Array.prototype.slice.call(this.node.querySelectorAll(selector)) : [];
    }

    band()
    {
        let scene = this.find(".wpScene");
        let height = scene ? scene.clientHeight : 0;

        if (!this.mobile)
            return { top : 0, bottom : height };

        let bar = this.find(".wpTopBar");
        let sheet = this.find(".wpSheet");
        return {
            top : bar ? bar.offsetTop + bar.offsetHeight : 0,
            bottom : sheet ? sheet.offsetTop : height,
        };
    }

    // the photo runs on under the sheet's rounded corners
    fitScene()
    {
        if (!this.mobile)
            return;

        let sheet = this.find(".wpSheet");
        if (sheet)
            this.find(".wpScene").style.height = (sheet.offsetTop + 30) + "px";
    }

    render()
    {
        return this.mobile ? this._renderMobile() : this._renderDesktop();
    }

    _renderDesktop()
    {
        // the panel on the left, the room on the right with "Commander" in its top right corner
        return  '<aside class="wpPanel">' +
                    '<div class="wpHead">' +
                        '<button type="button" class="wpBack" data-action="close">' + this._icon("back") + fx.text("Modifier") + '</button>' +
                        '<span class="wpLabel">' + fx.text("Aperçu 3D") + '</span>' +
                    '</div>' +
                    '<h1 class="wpTitle"></h1>' +
                    '<div class="wpPrice"></div>' +
                    '<div class="wpSection">' +
                        '<div class="wpSectionHead"><span>' + fx.text("Finition") + '</span><span class="wpFinishLabel"></span></div>' +
                        '<div class="wpFinishes" role="radiogroup" aria-label="' + fx.text("Finition") + '"></div>' +
                    '</div>' +
                    '<div class="wpSection">' +
                        '<div class="wpSectionHead"><span>' + fx.text("Taille") + '</span></div>' +
                        '<div class="wpSizes" role="radiogroup" aria-label="' + fx.text("Taille") + '"></div>' +
                    '</div>' +
                    '<div class="wpSection">' +
                        '<div class="wpSectionHead"><span>' + fx.text("Pièce") + '</span></div>' +
                        '<div class="wpRooms" role="radiogroup" aria-label="' + fx.text("Pièce") + '"></div>' +
                    '</div>' +
                '</aside>' +
                '<div class="wpScene">' +
                    '<div class="wpHint">' + this._icon("zoom") + fx.text("Glissez pour faire pivoter · molette pour zoomer") + '</div>' +
                    '<button type="button" class="wpCart" data-action="order"></button>' +
                    '<div class="wpViewBar">' +
                        '<button type="button" data-action="view" data-view="face" class="selected" aria-pressed="true">' + fx.text("Vue d'ensemble") + '</button>' +
                        '<button type="button" data-action="view" data-view="close" aria-pressed="false">' + fx.text("De près") + '</button>' +
                        '<span class="wpSeparator"></span>' +
                        '<button type="button" data-action="measure" class="wpMeasureButton" aria-pressed="false">' + this._icon("ruler") + fx.text("Dimensions") + '</button>' +
                    '</div>' +
                    this._loader() +
                '</div>';
    }

    _renderMobile()
    {
        let tab = (id, label, selected) =>
            '<button type="button" role="tab" data-action="tab" data-tab="' + id + '"' + (selected ? ' class="selected" aria-selected="true"' : ' aria-selected="false"') + '>' + label + '</button>';

        return  '<div class="wpScene">' +
                    this._loader() +
                '</div>' +
                '<div class="wpTopBar">' +
                    '<button type="button" class="wpBack" data-action="close">' + this._icon("back") + fx.text("Modifier") + '</button>' +
                    '<div class="wpViewBar">' +
                        '<button type="button" data-action="view" data-view="face" class="selected" aria-pressed="true">' + fx.text("Ensemble") + '</button>' +
                        '<button type="button" data-action="view" data-view="close" aria-pressed="false">' + fx.text("De près") + '</button>' +
                        '<span class="wpSeparator"></span>' +
                        '<button type="button" data-action="measure" class="wpMeasureButton" aria-pressed="false" aria-label="' + fx.text("Afficher les dimensions") + '">' + this._icon("ruler") + '</button>' +
                    '</div>' +
                '</div>' +
                '<div class="wpSheet">' +
                    '<div class="wpSheetHead"><h1 class="wpTitle"></h1><div class="wpPrice"></div></div>' +
                    '<div class="wpTabs" role="tablist">' +
                        tab("finish", fx.text("Finition"), true) +
                        tab("size", fx.text("Taille")) +
                        tab("room", fx.text("Pièce")) +
                    '</div>' +
                    '<div class="wpTabBody">' +
                        '<div class="wpFinishes selected" data-pane="finish" role="radiogroup" aria-label="' + fx.text("Finition") + '"></div>' +
                        '<div class="wpSizes" data-pane="size" role="radiogroup" aria-label="' + fx.text("Taille") + '"></div>' +
                        '<div class="wpRooms" data-pane="room" role="radiogroup" aria-label="' + fx.text("Pièce") + '"></div>' +
                    '</div>' +
                    '<div class="wpFooter"><button type="button" class="wpCart" data-action="order"></button></div>' +
                '</div>';
    }

    _loader()
    {
        return '<div class="wpLoader"><div class="wpSpinner"></div><span>' + fx.text("Préparation de l'aperçu…") + '</span></div>';
    }

    _icon(name)
    {
        let path = {
            back : '<path d="M15 18l-6-6 6-6"/>',
            ruler : '<path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2M10 10l2 2M13 7l2 2"/>',
            zoom : '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M8 10.5h5M10.5 8v5"/>',
        }[name];

        return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
    }
});
